import React from "react";

export default function Doc(props) {

    const fileConf = props.fileConf;

    return <>
        <div className={'detail-title'}>
            <p className={'canopia2 detail-title-font'}>{fileConf.desc}</p>
        </div>
        <p style={{paddingTop: '20px'}}>
            <iframe src={props.file} height="880rem" width="100%" frameBorder={0} title={fileConf.label}/>
        </p>
    </>;
}